import Amount from "@/models/Shared/Amount";

export default class CreateTransactionalFeeRequest {
    name: string = '';
    reference: string = '';
    transactionType: string = '';
    subTransactionType: string = '';
    fixedAmount: Amount = new Amount();
    percentage: number = 0;
    includeAmountInPercentage: boolean = false;
}